interface ReadinessDependencies {
    signal: AbortSignal;
    read(): Promise<'ready' | 'warming' | 'unavailable'>;
    wait(): Promise<void>;
    now(): number;
    onSlow(): void;
}
export async function waitForAgentReadiness(deps: ReadinessDependencies) {
    const began = deps.now();
    while (!deps.signal.aborted) {
        const status = await deps.read();
        if (deps.signal.aborted)
            throw new Error('cancelled');
        if (status === 'ready')
            return;
        if (status === 'unavailable' || deps.now() - began >= 300000)
            throw new Error('unavailable');
        if (deps.now() - began >= 30000)
            deps.onSlow();
        await deps.wait();
    }
    throw new Error('cancelled');
}
